import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user } from '@/hooks/store/use_slices';
import { set_interval } from '@/utils/utils_client';
import { format_size } from '@shared/utils/utils_files';
import { useState } from 'react';
import { UI_PRIMITIVE__tooltip } from '../../../components/ui/UI_PRIMITIVE__tooltip';

export function HARDWARE_STATS__ram() {
  const { is_authorized, user_settings } = use_slice_user(['is_authorized', 'user_settings']);

  const [ram_value, set_ram_value] = useState(0);

  /*
   * EFFECTS
   */

  use_effect(() => {
    check_ram_usage();

    const interval_id = set_interval(check_ram_usage, CONSTANTS_TIME__client.INTERVAL_RAM);

    return () => clearInterval(interval_id);
  }, []);

  /*
   * METHODS
   */

  async function check_ram_usage() {
    const performance_memory = window.performance.memory;

    let ram_value_new = performance_memory && typeof performance_memory.usedJSHeapSize === 'number' ? performance_memory.usedJSHeapSize : 0;

    set_ram_value(ram_value_new);
  }

  /*
   * HTML
   */

  if (!is_authorized) return <></>;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={`RAM: ${format_size(ram_value)}`}>
      <div className={`bg-bar py-2 flex-1 h-full overflow-hidden text-xs text-center text-page-foreground`}>{`${format_size(ram_value)}`}</div>
    </UI_PRIMITIVE__tooltip>
  );
}
